import fetchers from "./fetchers"
import setters from "./setters"

export default {
    ...fetchers,
    ...setters
}